// src/resources/POSMappings/POSMappingEdit.js
import React, { useState } from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  ReferenceInput,
  SelectInput,
  Button,
  useRecordContext,
  useRefresh,
  useNotify,
  useDataProvider,
} from "react-admin";

import {
  closeActiveAssignment,
  createNewAssignment,
} from "./posAssignmentUtils";

export const POSMappingEdit = (props) => {
  return (
    <Edit {...props} title="Edit POS Device Mapping">
      <POSMappingEditForm />
    </Edit>
  );
};

const POSMappingEditForm = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const dataProvider = useDataProvider();

  const [showReassign, setShowReassign] = useState(false);
  const [newVehicleId, setNewVehicleId] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDate, setStartDate] = useState("");

  if (!record) return null;

  const terminalId = record.terminalId;

  // 🔵 UNASSIGN BUTTON HANDLER
  const handleUnassign = async () => {
    if (!endDate) {
      notify("Please select end date.", { type: "warning" });
      return;
    }

    try {
      await closeActiveAssignment(terminalId, endDate);

      // Clear vehicleId from main mapping
      await dataProvider.update("posDeviceMappings", {
        id: record.id,
        data: {
          vehicleId: "",
          vehicleNumber: "",
          updatedAt: new Date(),
        },
      });

      notify("POS device unassigned successfully.", { type: "success" });
      refresh();
    } catch (err) {
      console.error(err);
      notify("Failed to unassign POS device.", { type: "error" });
    }
  };

  // 🔵 REASSIGN BUTTON HANDLER
  const handleReassign = async () => {
    if (!endDate || !startDate || !newVehicleId) {
      notify("Select end date, new start date and new vehicle.", {
        type: "warning",
      });
      return;
    }

    try {
      // Close old assignment
      await closeActiveAssignment(terminalId, endDate);

      // Create new assignment
      await createNewAssignment(terminalId, newVehicleId, startDate);

      notify("POS device reassigned successfully.", { type: "success" });
      setShowReassign(false);
      refresh();
    } catch (err) {
      console.error(err);
      notify("Failed to reassign POS device.", { type: "error" });
    }
  };

  return (
    <>
      {/* FORM UI */}
      <SimpleForm>
        <TextInput source="terminalId" label="Terminal ID" disabled fullWidth />

        <ReferenceInput source="vehicleId" reference="vehicles" label="Vehicle">
          <SelectInput optionText="vehicleNumber" />
        </ReferenceInput>

        <TextInput source="notes" label="Notes" fullWidth multiline />

        {/* 🔥 ACTION BUTTONS */}
        <div style={{ marginTop: 20, display: "flex", gap: 12 }}>
          {/* UNASSIGN BUTTON */}
          <div>
            <label>End Date (Unassign)</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              style={{ padding: 6, marginLeft: 10 }}
            />
            <Button
              label="Unassign"
              onClick={handleUnassign}
              style={{
                marginLeft: 12,
                background: "#d9534f",
                color: "white",
                padding: "8px 14px",
              }}
            />
          </div>

          {/* REASSIGN SECTION */}
          <Button
            label="Reassign POS"
            onClick={() => setShowReassign(!showReassign)}
            style={{
              background: "#0275d8",
              color: "white",
              padding: "8px 14px",
            }}
          />
        </div>

        {/* REASSIGN UI */}
        {showReassign && (
          <div
            style={{
              marginTop: 20,
              padding: 15,
              border: "1px solid #ddd",
              borderRadius: 6,
              background: "#f8f9fa",
            }}
          >
            <h4>Reassign POS Device</h4>

            <div style={{ marginTop: 10 }}>
              <label>Old Assignment End Date</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                style={{ marginLeft: 10, padding: 6 }}
              />
            </div>

            <div style={{ marginTop: 10 }}>
              <label>New Assignment Start Date</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                style={{ marginLeft: 10, padding: 6 }}
              />
            </div>

            <div style={{ marginTop: 10 }}>
              <label>Select New Vehicle</label>
              <ReferenceInput
                source="newVehicleId"
                reference="vehicles"
                label="Vehicle"
              >
                <SelectInput
                  onChange={(e) => setNewVehicleId(e.target.value)}
                  optionText="vehicleNumber"
                />
              </ReferenceInput>
            </div>

            <Button
              label="Confirm Reassign"
              onClick={handleReassign}
              style={{
                marginTop: 15,
                background: "green",
                color: "white",
                padding: "8px 14px",
              }}
            />
          </div>
        )}
      </SimpleForm>
    </>
  );
};
